import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MainModule } from './main/main.module';
import { StepperModule } from './stepper/stepper.module';

import { AngularFireAnalyticsModule, ScreenTrackingService, UserTrackingService, DEBUG_MODE } from '@angular/fire/analytics';
import { environment } from 'src/environments/environment.prod';
import { AngularFireModule } from '@angular/fire';
// import { NgxImageCompressService } from 'ngx-image-compress';

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    AngularFireModule.initializeApp(environment.firebaseConfig),
    AngularFireAnalyticsModule,
    MainModule,
    StepperModule
  ],
  providers: [
    ScreenTrackingService,
    UserTrackingService,
    // NgxImageCompressService,
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
